import countnovel from './countnovel'
import zimofree from './zimofree'
import novelKeepreadingbook from './novel-keepreadingbook'
import fictionfree from './fictionfree'
import e1free from './e1free'
import bzcase from './bzcase'
import bzhope from './bzhope'
import blurpyShop from './blurpy-shop'
import usdven from './usdven'
import hytosmXyz from './hytosm-xyz'

export const appConfig = {
    countnovel,
    fictionfree,
    zimofree,
    e1free,
    bzcase,
    bzhope,
    'blurpy_shop': blurpyShop,
    'novel_keepreadingbook':novelKeepreadingbook,
    'hytosm_xyz': hytosmXyz,
    usdven: usdven,
    default: {
        lang: 'en',
        company: 'durianovel.com',
        name: 'Durianovel',
        email: 'ops@novellettes.com',
        bgImg: 'https://static.novelfreedom.com/paynovel/h5-pay-asia/top-bg.png',
        theme: '#ff2667',
        discoverIcon: 'https://static.novelfreedom.com/paynovel/h5-pay-asia/icon_discover_active.png',
        mineIcon:'https://static.novelfreedom.com/paynovel/h5-pay-asia/icon_mine_active.png',
        logo: 'https://static.novelfreedom.com/paynovel/h5-pay-asia/logo.png',
        isAds: false,
        fbPixel: {
            1: '1438847163760449',
            2: '1789737104944898',
        },
        adx: {
            1: '/29746187,23215273386/HK_CN_keepreadingbook.com_banner_1',
            2: '/29746187,23215273386/HK_CN_keepreadingbook.com_banner_2',
            3: '/29746187,23215273386/HK_CN_keepreadingbook.com_banner_3',
        },
        ads: {
            1: '5142653642',
            2:'2968211590',
        },
        adsCaPubId: '7241813899388863',
        ga4: {
            id: 'G-3HG09Q8HKR'
        },
        adConfig: {
            // 关闭遮罩时间
            closeMaskTime: 20000,
            // 倒计时时间
            time: 400,
            // 20s 计数
            interTime: 20,
            // 是否可以点击穿透
            // 点击广告上线
            clickMax: 20,
        },
        content:{
            1: {
                split: '\n\n',
                textNum: 300,
                p: 3,
            },
        },
        pixelReport: {
            chapter: new Set([1, 3, 5, 10, 20, 30]),
            rate: 0.6
        }
    }
}